export const CTRMetafieldsByHandle = `
query CTRMetafieldsByHandle($query: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
  product(handle: $query) {
    CTR1: metafield(namespace: "my_fields", key: "complete_the_room_1") {
      value
    }
    CTR2: metafield(namespace: "my_fields", key: "complete_the_room_2") {
      value
    }
    CTR3: metafield(namespace: "my_fields", key: "complete_the_room_3") {
      value
    }
    CTR4: metafield(namespace: "my_fields", key: "complete_the_room_4") {
      value
    }
    CTR5: metafield(namespace: "my_fields", key: "complete_the_room_5") {
      value
    }
    CTR6: metafield(namespace: "my_fields", key: "complete_the_room_6") {
      value
    }
  }
}`;

export const CTLMetafieldsByTitle = `
query CTLMetafieldsByTitle($query: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
  products: products(first: 20, query: $query) {
    edges {
      node {
        id
        title
        ctl1:metafield(namespace:"my_fields", key:"complete_the_look_1") {
          value
        }
         ctl2:metafield(namespace:"my_fields", key:"complete_the_look_2") {
          value
        }
        ctl3:metafield(namespace:"my_fields", key:"complete_the_look_3") {
          value
        }
        ctl4:metafield(namespace:"my_fields", key:"complete_the_look_4") {
          value
        }
      }
    }
  }
}`;

export const metafieldsByProductHandle = `
  query metafieldsByProductHandle($handle: String!, $countryIso2: CountryCode!, $metaIdentifier: [HasMetafieldsIdentifier!]!, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  product(handle: $handle) {
    id
    title
    metafields(identifiers: $metaIdentifier)
    	{
    		namespace
    		key
     	 	value
      }
    }
  }
`;

// Fallback for surfaces that have no pre-serialized variant data (the Plytix JSON blob is what
// normally carries these). Fetches every variant in one request so a size change resolves from
// memory; only called when the theme settings actually name a variant-scoped metafield, so
// $metaIdentifier is never empty.
export const variantMetafieldsByProductHandle = `
  query variantMetafieldsByProductHandle($handle: String!, $countryIso2: CountryCode!, $metaIdentifier: [HasMetafieldsIdentifier!]!, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  product(handle: $handle) {
    id
    variants(first: 250) {
      edges {
        node {
          id
          metafields(identifiers: $metaIdentifier) {
            namespace
            key
            value
          }
        }
      }
    }
  }
}
`;

export const getOnlineStorePageById = `
  query PageShow($id: ID!) {
    page(id: $id) {
      body
      handle
      id
      title
    }
  }
`;

export const productVariantsByTitle = `
query variantsByTitle($query: String!, $countryIso2: CountryCode!,$images:Int, $totalProduct:Int, $imageNS: String = null, $imageKey: String = null, $imageNS2: String = null, $imageKey2: String = null, $vimageNS: String = null, $vimageKey: String = null, $bundleSwatchMetafieldNameSpace: String = null, $bundleSwatchMetafieldName: String = null, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  products: products(first: $totalProduct, query: $query) {
    edges {
      node {
        id
        handle
        title
        descriptionHtml
        tags
        productType
        vendor
        totalInventory
        media(first:$images) {
          edges {
            node {
              ... fieldsForMediaTypes
            }
          }
        }
        images (first:$images) {
          edges {
            node {
              id
              url
              altText
            }
          }
        }
        upsellProductOption:metafield(namespace:$imageNS,key:$imageKey){
          id,
          value
        }
        upsellProductOption2:metafield(namespace:$imageNS2,key:$imageKey2){
          id,
          value
        }
        bundleSwatch:metafield(namespace:$bundleSwatchMetafieldNameSpace,key:$bundleSwatchMetafieldName){
          id,
          value
          reference {
            ... on MediaImage {
              image {
                url
              }
            }
          }
        }
        variants(first: 250) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              product {
                id
              }
              components(first: 50) {
                edges {
                  node {
                    quantity
                    productVariant {
                      id
                      sku
                      image {
                        url
                      }
                      product {
                        handle
                        title
                      }
                      selectedOptions {
                        name
                        value
                      }
                    }
                  }
                }
              }
              quantityAvailable
              id
              image {
                id
                url
              }
              price{
                amount
                currencyCode
              }
              compareAtPrice{
                amount
                currencyCode
              }
              availableForSale
              selectedOptions{
                name
                value
              }
                upsellImage:metafield(namespace:$vimageNS,key:$vimageKey){
                references(first: 5) {
                  edges {
                    node {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
  fragment fieldsForMediaTypes on Media {
  alt
  ... on Video {
    id
    sources {
      format
      height
      mimeType
      url
      width
    }
  }
  ... on ExternalVideo {
    id
    host
    embeddedUrl
  }
  ... on MediaImage {
    id
    image {
      url
      width
      height
    }
  }
}
`;

export const productVariantsByHandle = `
query variantsByHandle($handle: String!, $countryIso2: CountryCode!,$images:Int, $imageNS: String = null, $imageKey: String = null, $imageNS2: String = null, $imageKey2: String = null, $vimageNS: String = null, $vimageKey: String = null, $bundleSwatchMetafieldNameSpace: String = null, $bundleSwatchMetafieldName: String = null, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  product(handle: $handle) {
    id
    handle
    title
    descriptionHtml
    tags
    productType
    vendor
    totalInventory
    media(first:$images) {
      edges {
        node {
          ... fieldsForMediaTypesByHandle
        }
      }
    }
    images (first:$images) {
      edges {
        node {
          id
          url
        }
      }
    }
    upsellProductOption:metafield(namespace:$imageNS,key:$imageKey){
      id,
      value
    }
    upsellProductOption2:metafield(namespace:$imageNS2,key:$imageKey2){
      id,
      value
    }
    bundleSwatch:metafield(namespace:$bundleSwatchMetafieldNameSpace,key:$bundleSwatchMetafieldName){
      id,
      value
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    variants(first: 250) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          product {
            id
          }
          components(first: 50) {
            edges {
              node {
                quantity
                productVariant {
                  id
                  sku
                  image {
                    url
                  }
                  product {
                    handle
                    title
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
          quantityAvailable
          id
          image {
            id
            url
          }
          price{
            amount
            currencyCode
          }
          compareAtPrice{
            amount
            currencyCode
          }
          availableForSale
          selectedOptions{
            name
            value
          }
          upsellImage:metafield(namespace:$vimageNS,key:$vimageKey){
            references(first: 5) {
              edges {
                node {
                  ... on MediaImage {
                    id
                    image {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
  fragment fieldsForMediaTypesByHandle on Media {
  alt
  ... on Video {
    id
    sources {
      format
      height
      mimeType
      url
      width
    }
  }
  ... on ExternalVideo {
    id
    host
    embeddedUrl
  }
  ... on MediaImage {
    id
    image {
      url
      width
      height
    }
  }
}
`;

export const productSwatchesByTitle = `
query productSwatchesByTitle($query: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
  products: products(first: 20, query: $query) {
    edges {
      node {
        id
        handle
        title
        variants(first: 250) {
          edges {
            node {
              product {
                id
              }
              quantityAvailable
              id
              availableForSale
              selectedOptions{
                name
                value
              }
            }
          }
        }
      }
    }
  }
}
`;
export const productSwatches = `
  query productByTitle($query: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
    product: products(first: 20, query: $query) {
      edges {
        node {
          id
          title
          handle
          tags
          options(first: 10) {
            name
            optionValues {
              name
            }
          }
        }
      }
    }
  }
`;

export const completeTheRoom = `
query completeTheRoom($ids: [ID!]!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
  nodes(ids: $ids) {
    ...on Product {
      id
      title
      handle
      availableForSale
      tags
      images(first: 1) {
        edges {
          node {
            url
          }
        }
      }
      variants(first: 250) {
        edges {
          node {
            id
            sku
            product {
              id
            }
            image {
              id
              url
            }
            price{
              amount
              currencyCode
            }
            compareAtPrice{
              amount
              currencyCode
            }
            availableForSale
            selectedOptions{
              name
              value
            }
          }
        }
      }
    }
  }
}
`;

export const completeTheLook = `
query completeTheLook($ids: [ID!]!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
  nodes(ids: $ids) {
    ...on Product {
      id
      title
      handle
      images(first: 1) {
        edges {
          node {
             url
          }
        }
      }
    }
  }
}
`;
export const productMasterByIds = `
query productMasterByIds($query: String!, $countryIso2: CountryCode!, $imageNS: String = null, $imageKey: String = null, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  products: products(first: 50, query: $query) {
    edges {
      node {
        id
        handle
        title
        descriptionHtml
        tags
        totalInventory
        productType
        vendor
        images (first:5) {
          edges {
            node {
              id
              url
            }
          }
        }
        variants(first: 250) {
          edges {
            node {
              id
              product {
                id
              }
              image {
                id
                url
              }
              price{
                amount
                currencyCode
              }
              compareAtPrice{
                amount
                currencyCode
              }
              availableForSale
              selectedOptions{
                name
                value
              }
              upsellImage:metafield(namespace:$imageNS,key:$imageKey){
                references(first: 5) {
                  edges {
                    node {
                      ... on MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const getCollectionByGid = `
  query getCollectionByGid($id: ID!) {
    collection(id: $id) {
      id
      handle
    }
  }
`;

export const getCollectionProductsWithMetafields = `
  query getCollectionProductsWithMetafields($id: ID!, $namespace: String!, $key: String!, $buyer: BuyerInput) @inContext(buyer: $buyer) {
    collection(id: $id) {
      id
      title
      products(first: 50) {
        edges {
          node {
            id
            title
            handle
            tags
            media(first: 1) {
              nodes {
                id
              }
            }
            metafield(namespace: $namespace, key: $key) {
              id
              namespace
              key
              value
              reference {
                ... on MediaImage {
                  alt
                  image {
                    altText
                    url(transform: {maxWidth: 800 })
                    width
                    height
                  }
                }
              }
            }
            reviewsRating: metafield(namespace: "reviews", key: "rating") {
              value
            }
            reviewsRatingCount: metafield(namespace: "reviews", key: "rating_count") {
              value
            }
            variants(first: 250) {
              edges {
                node {
                  id
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  availableForSale
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const moreProductVariants = `
query moreProductVariants($productId: ID!, $after: String!, $countryIso2: CountryCode!, $vimageNS: String = null, $vimageKey: String = null, $buyer: BuyerInput) @inContext(country: $countryIso2, buyer: $buyer) {
  node(id: $productId) {
    ... on Product {
      variants(first: 250, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            product {
              id
            }
            components(first: 50) {
              edges {
                node {
                  quantity
                  productVariant {
                    id
                    sku
                    image {
                      url
                    }
                    product {
                      handle
                      title
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
            }
            quantityAvailable
            id
            image {
              id
              url
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            availableForSale
            selectedOptions {
              name
              value
            }
            upsellImage:metafield(namespace:$vimageNS,key:$vimageKey){
              references(first: 5) {
                edges {
                  node {
                    ... on MediaImage {
                      id
                      image {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const caCustomerIdForMetafield = `
query CaCustomerIdForMetafield { customer { id } }
`;

export const caSetCookieOptInMetafield = `
mutation SetCookieOptIn($metafields: [MetafieldsSetInput!]!) {
  metafieldsSet(metafields: $metafields) {
    metafields { id namespace key type value }
    userErrors { field message code }
  }
}
`;
